module.exports = __webpack_public_path__ + "static/media/others-banner.f17565d8.png";